import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import {
    Button,
    Collapse,
    Divider,
    ListItem,
    ListItemText,
    Theme,
    Typography,
    withTheme, 
    WithTheme 
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import VendorDeleteModal from './DeleteModal';
import VendorEditModal from './AddEditModal';
import { IReturn as Vendor, actions as vendorActions } from '../../api/resources/Vendor';

const styles = (theme: Theme) =>
    createStyles({
        content: {
            padding: '8px 16px',
        },
        itemActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        itemSection: {
            flexBasis: '100%',
        }
    });

interface IProps {
    index: number;
    vendor: Vendor;
};

interface IState {
    expanded: boolean;
    showDeleteModal: boolean;
    showEditModal: boolean;
}

type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class VendorItem extends React.PureComponent<FullProps> {
    public state = {
        expanded: false,
        showDeleteModal: false,
        showEditModal: false,
    }
    
    render() {
        const { index, vendor, classes } = this.props;
        const { expanded, showDeleteModal, showEditModal } = this.state;

        return (
            <React.Fragment>
                {index !== 0 && (
                <Divider component="li" />
                )}
                <ListItem button onClick={this.handleExpandClick}>
                    <ListItemText className={classes.itemSection} primary={vendor.name} secondary={(
                        <>{vendor.entity_type} - {vendor.identifier}</>
                    )}/>
                    <ListItemText className={classes.itemSection} secondary={(
                        <>
                            {vendor.street1}
                            {vendor.street2 && (<><br />{vendor.street2}</>)}
                            <br />{vendor.city}, {vendor.state} {vendor.zip_code}
                        </>
                    )} />
                    {expanded ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div className={classes.content}>
                        <Typography variant="subtitle2">
                            Point of contact
                        </Typography>
                        <Typography variant="body2">
                            {vendor.contact_first_name} {vendor.contact_last_name}<br />
                            {vendor.contact_email}<br />
                            {vendor.contact_phone}
                        </Typography>
                    </div>
                    <div className={classes.itemActions}>
                        <Button onClick={this.handleDeleteClick}>Delete</Button>
                        {/* <Button color="primary">Activate</Button> */}
                        <Button onClick={this.handleEditClick} color="primary">Edit</Button>
                    </div>
                </Collapse>
                <VendorDeleteModal open={showDeleteModal} onDismiss={this.handleDeleteDismiss} />
                <VendorEditModal vendor={vendor} open={showEditModal} onDismiss={this.handleEditDismiss} />
            </React.Fragment>
        )
    }

    private handleExpandClick = () => {
        this.setState({expanded: !this.state.expanded});
    }

    private handleDeleteClick = () => {
        this.setState({showDeleteModal: true});
    }

    private handleDeleteDismiss = (shouldDelete: boolean) => {
        if (shouldDelete) {
            const { dispatch, vendor } = this.props;
            dispatch(vendorActions.delete(vendor.id)).catch(console.error);
        }
        this.setState({showDeleteModal: false});
    }

    private handleEditClick = () => {
        this.setState({showEditModal: true});
    }

    private handleEditDismiss = (shouldRefresh: boolean) => {
        this.setState({showEditModal: false});
    }
}

export default connect()(withTheme(withStyles(styles)(VendorItem)));